import _ from 'lodash';

// we're just getting the first one for now..
function getGraphQLErrorCode (error) {
  return _.get(error, 'graphQLErrors[0].code', null);
}

export default getGraphQLErrorCode;
